import { type ApiItem, type BasketItem, ProductTypes } from '@virginexperiencedays/basket';

export const mapBasketItems = (items: ApiItem[], reverse?: boolean): BasketItem[] => {
  if (!Array.isArray(items)) return [];

  const mappedItems: BasketItem[] = items.map(mapBasketItem);

  return reverse ? mappedItems.reverse() : mappedItems;
};

export const mapBasketItem = (item: ApiItem): BasketItem => {
  const id = item?.Id ?? '';
  const sku = item?.SKU ?? '';
  const title = item?.Name ?? '';
  const qty = item?.Qty ?? 0;
  const rrp = item?.RRP ?? 0;
  const displayPrice = item?.UnitPrice ?? 0;
  const discountedPrice = item?.UnitPriceInclDiscount ?? 0;
  const image = {
    src: item?.ProductImageThumbURL ?? '',
    alt: item?.TrimmedName ?? item?.Name ?? '',
  };
  const categories = Array.isArray(item?.Category) ? item?.Category : [String(item?.Category)];
  const slug = item?.ProductUrl?.split('/product/')?.[1] ?? '';
  const rowTotal = item?.Subtotal ?? 0;
  const url = item?.ProductUrl ?? '';
  const isCollectionProduct = item?.ProductTypeId === ProductTypes.Collection;

  return {
    id,
    sku,
    title,
    qty,
    rrp,
    displayPrice,
    discountedPrice,
    image,
    categories,
    slug,
    rowTotal,
    url,
    isCollectionProduct,
  };
};
